//Import React Hooks
import { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';

// import created components  :
import CardArticle from '../cardArticle/CardArticle'

//selectors for redux :
import { useSelector, useDispatch } from "react-redux";


//MUI :
import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal';
import Alert from '@mui/material/Alert';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';

// API fetch
import axios from "axios";
import { baseURL } from '../../../config/api-config.js';


//Translate utils :
import { translator } from "../../../utils/translator.js"

//import { useSelector, useDispatch } from "react-redux";
import { getLang, getLocation, getStepLocation, getPanier } from "../../../store/selectors.js"; //global state : shopping state
import { locationSlice } from '../../../store/locationSlice.js';
import { panierSlice } from '../../../store/panierSlice.js';
//const lang = useSelector(getLang) //global state : language
// translator(original, lang, ref)

export default function ShoppingGallery({ dbArticles, dbTailles }) {



    return (
        <div className="location-gallery">

            <div className="location-gallery-list">
                {dbArticles.map(article => (
                    <CardArticle key={article.id_article} article={article} dbTailles={dbTailles} />
                ))}

            </div>
        </div>
    )
}
